import React, { useState, useContext, useEffect } from "react";
import { AppContext } from "../../context/AppContext";
import { useLocation, useNavigate } from "react-router-dom";
import verticle from "../../assets/images/verticle_line.svg";
import Select from "react-select";
import { PostCallWithErrorResponse, simpleGetCallWithToken } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import Loader from "../Loader";
import { notifyError, notifySuccess } from "../../toaster/notify";
import { ClipLoader } from "react-spinners";
import "../../assets/css/MasterData.scss"
import AccessPermission from "./AccessPermission";

const Permission = () => {
    const { sidebar, socket } = useContext(AppContext);
    const Route = useLocation().pathname;
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const [loading, setLoading] = useState(false)
    const [permissions, setPermissions] = useState([]);
    const [permissionData, setPermissionData] = useState({
        role: 0,
        permissionsList: [],
        RoleName: ""
    });
    console.log("permissionData", permissionData);

    const [roleDropdownList, setRoleDropdownList] = useState([]);
    const [RoleNameEmit, setRoleName] = useState("");


    const sortedOptions = roleDropdownList.slice().sort((a, b) => a.label.localeCompare(b.label));
    console.log("sortedOptions", sortedOptions);

    useEffect(() => {
        getAllPermissionList();
        getUserRoleList();
    }, []);

    const getAllPermissionList = async () => {
        try {
            setLoading(true);
            const res = await simpleGetCallWithToken(ApiConfig.GET_ALL_PERMISSIONS);
            console.log("first permission,", res);
            if (res.Success === true) {
                setPermissions(res.Data);
                setLoading(false);
            } else {
                setLoading(false);
            }
        } catch (error) {
            console.log("catch error")
        } finally {
            setLoading(false);
        }

    };

    const getPermissionsByRoleID = async (roleId) => {

        try {
            setLoading(true);
            const res = await simpleGetCallWithToken(
                ApiConfig.GER_PERMISSIONS_BY_ROLEID + `/${roleId}`
            );
            if (res.Success) {
                setPermissions(res.Data);
                console.log(res.Data);
                setLoading(false);
                let roles = [];
                res.Data.map((category) => {
                    category.Permissions.map((role) => {
                        if (role.IsSelected === true) {
                            roles.push(role.PermissionId);
                        }

                        if (role?.SubPermissions?.length > 0) {

                            role?.SubPermissions?.map((perm) => {

                                if (perm?.IsSelected) {

                                    roles.push(perm?.PermissionId)

                                }

                            })

                        }
                    })
                }
                );
                setPermissionData({
                    ...permissionData,
                    role: res.Data[0].RoleId,
                    permissionsList: roles,
                    role: roleId

                });
            } else {
                setLoading(false);
            }
        } catch (error) {
            console.log("error respinse,", error);
        }
    };

    const getUserRoleList = async () => {
        try {
            const res = await simpleGetCallWithToken(ApiConfig.GET_ALL_ROLE_NAMES);
            console.log("res=", res);
            if (res.Success === true) {
                let roleDropdownArr = [];
                res.Data && res.Data.forEach((item) => {
                    if (item?.IsActive) {
                        roleDropdownArr.push({
                            label: item.Name,
                            value: item.RoleId,

                        })
                    }
                })
                setRoleDropdownList(roleDropdownArr);
            }
        } catch (error) {
            console.log(error);
        }
    };
    const [loader, setLoader] = useState(false)
    const updatePermissions = () => {

        console.log(permissionData);

        if (permissionData.role === 0) {
            notifyError("Please select role name");
        } else {
            setLoader(true);
            PostCallWithErrorResponse(
                ApiConfig.UPDATE_PERMISSIONS,
                JSON.stringify(permissionData)
            )
                .then((res) => {
                    notifySuccess("Permissions assigned successfully");
                    setLoader(false);
                    socket.emit("roleAccess-update", {
                        RoleId: permissionData.role,
                        RoleName: RoleNameEmit,

                    });
                })
                .catch((err) => console.log(err));
        }
    };

    const IsSelected = (module) => {


        let selected = []

        module?.Permissions?.forEach((per) => {



            if (per?.SubPermissions.length > 0) {


                per?.SubPermissions.forEach((i) => {
                    selected.push(i?.PermissionId)
                })

            } else selected.push(per?.PermissionId)

        })


        return selected?.every((i) => permissionData?.permissionsList.includes(i))


    }

    const handleGetPermissionByRoleID = (roleData) => {
        setPermissionData({
            role: roleData.value,
            permissionsList: [],
            RoleName: roleData.label
        });
        setRoleName(roleData.label)
        setPermissions([]);
        getPermissionsByRoleID(roleData.value);
    }


    return (
        <div
            className={sidebar ? "taskMain " : "cx-active taskMain"}
            id="cx-main"
        >
            <div className="role-content mb-4">
                <div className="sub-header-role sub-header-role-arbaz-responsive ">
                    <span
                        onClick={() => {
                            navigate("/Role");
                        }}
                    >
                        <h6 className="mt-2 role-text">Role</h6>
                    </span>
                    <div className="span-wrapper-sub-header">
                        <span
                            onClick={() => {
                                navigate("/Role");
                            }}
                            className={
                                Route === "/Role"
                                    ? "sub-header-span-active"
                                    : "sub-header-span"
                            }
                        >
                            Create
                        </span>
                        <img src={verticle} alt="" style={{ marginRight: "20px" }} />
                        <span
                            className={
                                Route === "/AssignRole"
                                    ? "sub-header-span-active"
                                    : "sub-header-span"
                            }
                            style={{ marginRight: "20px" }}
                            onClick={() => {
                                navigate("/AssignRole");
                            }}
                        >
                            Assign
                        </span>
                        <img src={verticle} alt="" style={{ marginRight: "20px" }} />
                        <span
                            className={
                                Route === "/Permission"
                                    ? "sub-header-span-active"
                                    : "sub-header-span"
                            }
                            onClick={() => {
                                navigate("/Permission");
                            }}
                        >
                            Permissions
                        </span>
                        {/* <img src={verticle} alt="" /> */}
                    </div>
                </div>
            </div>
            <AccessPermission permissionData={permissions} setPermissions={setPermissions}
                handleGetPermissionByRoleID={handleGetPermissionByRoleID}
                roles={roleDropdownList}
                updatePermissions={updatePermissions}
                setPermissionData={setPermissionData}
                permissionDetails={permissionData}
                selectedPermission={permissionData?.permissionsList}
            />
            {/* <div className="permission-content-wrapper">
                <div className="row mb-4">
                    <div className="col-lg-6">
                        <label htmlFor="" className="label-text">
                            Role Names
                        </label>
                        <Select
                            options={sortedOptions}
                            onChange={(roleData) => {
                                setPermissionData({
                                    role: roleData.value,
                                    permissionsList: [],
                                    RoleName: roleData.label
                                });
                                setRoleName(roleData.label)
                                setPermissions([]);
                                getPermissionsByRoleID(roleData.value);
                            }}
                        />
                        {console.log("Role data on change --------", setPermissionData)}


                    </div>
                </div>

                {
                    loading ? <Loader /> : (
                        permissions && permissions.length > 0 && permissions.map((item, index) => {

                            return (
                                <>
                                    <div className="permission-heading mt-3">
                                        <label htmlFor="User" >{item?.CategoryName}</label>
                                        <input
                                            checked={IsSelected(item)}
                                            type="checkbox"
                                            id="Users" className="form-check-input ms-4"
                                            onChange={(e) => {

                                                let selected = []

                                                item?.Permissions?.forEach((i) => {

                                                    if (i?.SubPermissions) {

                                                        selected.push(i?.PermissionId)

                                                        i.SubPermissions.forEach((sub) => {

                                                            selected.push(sub?.PermissionId)

                                                        })

                                                    }

                                                })



                                                setPermissionData({
                                                    ...permissionData,
                                                    permissionsList: e.target.checked
                                                        ? [
                                                            ...permissionData?.permissionsList,
                                                            ...selected
                                                        ]
                                                        : permissionData.permissionsList.filter(
                                                            (per) => selected.indexOf(per) === -1
                                                        ),
                                                })

                                            }}
                                        />
                                    </div>
                                    <div style={{ marginTop: "0px" }}>
                                        <hr style={{ margin: "0px", border: '2px solid grey' }} />
                                    </div>
                                    <div className="row ">
                                        {
                                            item.Permissions &&
                                            item.Permissions.length > 0 &&
                                            item.Permissions.map((innerItem) => {
                                                return (
                                                    <>

                                                        <div className="col-lg-4 checkbox-wrapper">
                                                            <input
                                                                className="form-check-input "
                                                                type="checkbox"
                                                                name="checkbox1"
                                                                id="checkbox1"
                                                                checked={
                                                                    innerItem?.SubPermissions?.length === 0 ? permissionData?.permissionsList?.includes(innerItem?.PermissionId) :
                                                                        innerItem?.SubPermissions?.every((i) => permissionData?.permissionsList.includes(i.PermissionId))}

                                                                onChange={(e) => {

                                                                    let select = []

                                                                    if (innerItem?.SubPermissions?.length === 0) {
                                                                        select.push(innerItem?.PermissionId)
                                                                    } else {

                                                                        select = innerItem?.SubPermissions?.map((i) => i.PermissionId)
                                                                    }


                                                                    setPermissionData({
                                                                        ...permissionData,
                                                                        permissionsList: e.target.checked
                                                                            ? [
                                                                                ...permissionData.permissionsList,
                                                                                ...select
                                                                            ]
                                                                            : permissionData.permissionsList.filter(
                                                                                (per) => select.indexOf(per) === -1
                                                                            ),
                                                                    });
                                                                }}
                                                            />
                                                            <label for="checkbox" className="terms-text-1 ms-2 "
                                                                style={innerItem?.SubPermissions?.length > 0 ? { fontWeight: "bold" } : null}
                                                            >
                                                                {innerItem?.PermissionName}{" "}
                                                            </label>
                                                        </div>

                                                        {
                                                            innerItem?.SubPermissions?.length > 0 &&
                                                            <div className="col-lg-12 row mb-2 ml-4 ">
                                                                {
                                                                    innerItem?.SubPermissions?.length > 0 && innerItem.SubPermissions.map((per) => {
                                                                        return <div className="col-lg-4 checkbox-wrapper">
                                                                            <input
                                                                                className="form-check-input "
                                                                                type="checkbox"
                                                                                name="checkbox1"
                                                                                id="checkbox1"
                                                                                checked={permissionData?.permissionsList
                                                                                    ?.includes(
                                                                                        per.PermissionId
                                                                                    )}

                                                                                onChange={(e) => {



                                                                                    setPermissionData({
                                                                                        ...permissionData,
                                                                                        permissionsList: e.target.checked
                                                                                            ? [
                                                                                                ...permissionData.permissionsList,
                                                                                                per?.PermissionId
                                                                                            ]
                                                                                            : permissionData.permissionsList.filter(
                                                                                                (perm) => perm != per.PermissionId
                                                                                            ),
                                                                                    });
                                                                                }}

                                                                            />
                                                                            <label for="checkbox" className="terms-text-1 ms-2">
                                                                                {per?.PermissionName}{" "}
                                                                            </label>
                                                                        </div>
                                                                    })
                                                                }
                                                                <div style={{ marginTop: "5px" }}>
                                                                    <hr style={{ margin: "0px" }} />
                                                                </div>
                                                            </div>
                                                        }

                                                    </>
                                                )
                                            })
                                        }

                                    </div>
                                </>
                            )
                        })
                    )
                }




                <hr style={{ margin: "0px" }} className="mb-3" />
                <div className="text-end">

                    <button
                        onClick={updatePermissions}
                        className="save-btn-permission save-btn-permission-arbaz-responsive punchInButton"
                        disabled={loader ? true : false}
                    >
                        {loader ? (<div className="d-flex justify-content-center align-items-center">
                            <ClipLoader color="#fff"
                                size={18}
                            />
                        </div>) : "Save"}
                    </button>
                </div>


            </div> */}

        </div>
    )
}

export default Permission;
